/**
 * The Commons — records that are not one sport's alone.
 *
 * One India rather than one per sport, one Wankhede rather than one per sport
 * that plays there. They live outside every sport because that is what they
 * are: renaming India is not cricket's to do, and a medal table needs there to
 * be exactly one of it.
 *
 * A record arrives here by being told which sports see it, on the record
 * itself. This page is the register, not the way in.
 */

import { Link } from "react-router-dom";

import { Card, Empty, PageHead, Pill, Problem, Section, Table, Td, Th } from "@/components/kit";
import { listCommons } from "@/lib/api/client";
import { displayName } from "@/lib/format";
import { useApi } from "@/spa/useApi";

export function CommonsPage() {
  const { data: page, loading, error } = useApi(listCommons, [], "failed to load");

  if (error) return <Problem>Could not load the Commons: {error}</Problem>;
  if (!page) return <PageHead title="Commons" note={loading ? "Loading…" : ""} />;

  return (
    <>
      <PageHead
        title="Commons"
        note={
          page.total === 0
            ? "Nothing shared yet"
            : `${page.total} record${page.total === 1 ? "" : "s"} shared across sports`
        }
      />

      <Section title="Shared records">
        {page.rows.length === 0 ? (
          <Card>
            <Empty
              title="Nothing here yet"
              note="Open a record in any sport and set which sports can see it. Leave it in none and every sport sees it — which is what a country or a venue usually wants."
            />
          </Card>
        ) : (
          <Table>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>Kind</Th>
                <Th>Country</Th>
                <Th>Seen by</Th>
              </tr>
            </thead>
            <tbody>
              {page.rows.map((row) => (
                <tr key={row.id}>
                  <Td strong>{row.name}</Td>
                  <Td quiet>{row.master}</Td>
                  <Td quiet>{row.country ?? "—"}</Td>
                  <Td>
                    {row.sports.length === 0 ? (
                      <Pill tone="accent">every sport</Pill>
                    ) : (
                      <span style={{ display: "inline-flex", gap: "var(--s1)", flexWrap: "wrap" }}>
                        {row.sports.map((sport) => (
                          <Link key={sport} to={`/${sport}`} style={{ textDecoration: "none" }}>
                            <Pill>{displayName(sport)}</Pill>
                          </Link>
                        ))}
                      </span>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Section>
    </>
  );
}
